import { render, staticRenderFns } from "./CourseSeriesDetail.vue?vue&type=template&id=0e27cd5f&"
import script from "./CourseSeriesDetail.vue?vue&type=script&lang=js&"
export * from "./CourseSeriesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports